import React from 'react';
import { ElseTextField } from 'app/pages/Survey/Subject/elements';
import { addOptionPrefix } from 'app/modules/subject';
import Select from './Select';
import { useChoiceOneAnswer } from '../hooks';

function SelectType() {
  const {
    optionStates,
    value,
    options,
    onChange,
    elseValue,
    elseOption,
    onElseChange,
    onElseFinished
  } = useChoiceOneAnswer();

  return (
    <>
      {options && optionStates && (
        <Select
          value={value}
          onChange={onChange}
          options={options}
          optionStates={optionStates}
        />
      )}
      {elseOption && addOptionPrefix(elseOption.ID) === elseValue && (
        <ElseTextField
          initialValue={elseValue}
          onChange={onElseChange}
          onFinished={onElseFinished}
        />
      )}
    </>
  );
}

export default SelectType;
